import React, { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Alert, Row, Col, List, Typography } from "antd";

import {
  checkWrappings,
  groupCollisByWrapping,
} from "../../../modules/consignmentFunctions";
import InformationModal from "../../app/generic/informationModal";

const { Text } = Typography;

const getGroupCount = (group) => (group ? group[1].length : 0);

export default function WrappingCheck({
  rules,
  collis,
  wrappings,
  wrappingModalVisible,
  onSetWrappingModalVisible,
}) {
  const intl = useIntl();

  const [result, setResult] = useState();
  const [groups, setGroups] = useState();
  useEffect(() => {
    collis && setGroups(groupCollisByWrapping(collis, wrappings));
    setResult(checkWrappings(collis, wrappings, rules));
  }, [collis, wrappings, rules]);

  return (
    <>
      {rules.wrappings && (
        <InformationModal
          visible={wrappingModalVisible}
          title={intl.formatMessage({
            id: "messages.warning",
            defaultMessage: "Upozornění",
          })}
          setVisible={onSetWrappingModalVisible}
        >
          <Text strong>
            {intl.formatMessage({
              id: "consignment.colli.wrapping.warn",
              defaultMessage:
                "Vybraný produkt obsahuje omezení obalových materiálů.",
            })}
          </Text>
          <Row type="flex" justify="center">
            <Col span={14}>
              <List
                size="small"
                dataSource={Object.keys(rules.wrappings).filter(
                  (w) => !wrappings || wrappings.some((ww) => ww.code === w)
                )}
                renderItem={(key) => (
                  <List.Item>
                    <Text>
                      {wrappings?.find((w) => w.code === key)?.name ?? key}
                    </Text>
                    <Text>
                      {`${
                        rules.wrappings[key] ??
                        intl.formatMessage({
                          id: "consignment.colli.wrapping.unlimited",
                          defaultMessage: "neomezeně",
                        })
                      } (${getGroupCount(groups.find((g) => g[0] === key))})`}
                    </Text>
                  </List.Item>
                )}
              />
            </Col>
          </Row>
        </InformationModal>
      )}
      {result || !rules || !rules.wrappings ? (
        <></>
      ) : (
        <Col span={24}>
          <Alert
            type="error"
            message={
              <FormattedMessage
                id="consignment.colli.wrapping.error"
                defaultMessage="Zadané kusy nesplňují podmínky vybraného produktu! Více informací naleznete <a>zde</a>."
                values={{
                  a: (c) => (
                    <Text
                      underline
                      className="pointer"
                      onClick={() => onSetWrappingModalVisible(true)}
                    >
                      {c}
                    </Text>
                  ),
                }}
              />
            }
          />
        </Col>
      )}
    </>
  );
}
